"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const CallOff = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#clip0_171_58773)"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.152 10.832a.909.909 0 01-1.044.288L11.7 10.04a.2.2 0 01-.03-.026L6.93 4.797a.227.227 0 01.144-.38c2.443-.262 4.985.518 6.81 2.343 1.136 1.136 1.246 2.81.267 4.072zM3.792 2.694a.455.455 0 10-.674.612l1.57 1.726A8.068 8.068 0 002.114 6.76C.978 7.897.868 9.57 1.847 10.832a.909.909 0 001.045.288l2.784-.986.016-.007a.909.909 0 00.554-.666l.335-1.676c.16-.055.323-.1.487-.136l5.143 5.657a.455.455 0 10.672-.612l-9.092-10z",
  className: "fill"
})), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "clip0_171_58773"
}, /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  transform: "translate(.727 .727)",
  d: "M0 0h14.546v14.546H0z"
}))));

var _default = CallOff;
exports.default = _default;